<div class="menu" [class.closed]="!menuOpen">
  <div class="logo-area">
    <div class="logo-wrapper" [class.menu-closed]="!menuOpen">
      <img *ngIf="menuOpen" class="logo" alt="logo" (click)="goToTopPage()" ngbTooltip="ダッシュボード画面へ移動" src="/assets/img/peace_logo_yoko.png" />
      <img *ngIf="!menuOpen" class="logo" alt="logo" (click)="goToTopPage()" ngbTooltip="ダッシュボード画面へ移動" src="/assets/img/peace_logo_tate.png" />
    </div>
  </div>

  <ul>
    <li class="root-menu">
      <a class="menu-item" routerLink="/kymw/1002" routerLinkActive="active" [tabindex]="0" #dashboard
        (keydown.Space)="routingTo($event)">
        <fa-icon class="menu-icon" [icon]="faHome" ngbTooltip="ダッシュボード"></fa-icon>
        <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ダッシュボード</div>
      </a>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['goodsInfoManagement'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.goodsInfoManagement" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.goodsInfoManagement = !parentMenusOpen.goodsInfoManagement : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.goodsInfoManagement = !parentMenusOpen.goodsInfoManagement : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconGoodsInfoManagement" ngbTooltip="商品情報管理"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">商品情報管理</div>
        <fa-icon [icon]="parentMenusOpen.goodsInfoManagement ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="商品情報管理"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.goodsInfoManagement && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['goodsInfoManagement']['KYMW6900'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/6900" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.goodsInfoManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6900">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">商品提案検索</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['goodsInfoManagement']['KYMW1100'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1100" routerLinkActive="active" (keydown.Space)="routingTo($event)" 
            [tabindex]="parentMenusOpen.goodsInfoManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW1100">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">商品マスタ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['goodsInfoManagement']['KYMW4200'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4200" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.goodsInfoManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW4200">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">商品マスタプルーフ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['goodsInfoManagement']['KYMW4700'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4700" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.goodsInfoManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4700">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">マルチコード一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['goodsInfoManagement']['KYMW4300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.goodsInfoManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW4300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">商品ＤＮＡ情報一覧</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['planGoods'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.planGoods" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.planGoods = !parentMenusOpen.planGoods : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.planGoods = !parentMenusOpen.planGoods : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconPlanGoods" ngbTooltip="商品企画"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">商品企画</div>
        <fa-icon [icon]="parentMenusOpen.planGoods ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="商品企画"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.planGoods && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW1300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">商品企画マスタ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW1200'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1200" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1200">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">サイクル設定</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW4500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特集マスタ</div>
          </a>
        </li>
        <!-- CX -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7000'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7000" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7000">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集掲載商品選定（CX）</div>
          </a>
        </li>
        <!-- CXデザイン部用 -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7004'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7004" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7004">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特集商品提案状況確認<br>（CXデザイン部用）</div>
          </a>
        </li>
        <!-- グループ長用 -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7006'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7006" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7006">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集商品選定依頼確認<br>（グループ長用）</div>
          </a>
        </li>
        <!-- バイヤー -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7001'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7001" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7001">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集掲載商品選定（バイヤー）</div>
          </a>
        </li>
        <!-- 担当バイヤー用 -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7007'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7007" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7007">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集商品選定依頼確認<br>（担当バイヤー用）</div>
          </a>
        </li>
        <!-- 取引先用 -->
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7003'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7003" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7003">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特集商品提案状況確認<br>（取引先用）</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">計画数確認</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW2900'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2900"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW2900)"
            (click)="openDialogComponent(dialogComponents.KYMW2900)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">農産フロント連携</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW4000'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4000"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW4000)"
            (click)="openDialogComponent(dialogComponents.KYMW4000)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">週次プロモーション商品計画表</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW6700'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/6700" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6700">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">校正紙</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW6600'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6600"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW6600)"
            (click)="openDialogComponent(dialogComponents.KYMW6600)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特別指示書</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW7400'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7400" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7400">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">忘れず注文商品一覧</div>
          </a>
        </li>
        <!-- 不使用のためコメントアウト-->
        <!-- <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW2800'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2800"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW2800)"
            (click)="openDialogComponent(dialogComponents.KYMW2800)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">週別部門別供給高ＧＰ予算進捗</div>
          </a>
        </li> -->
        <!-- 不使用のためコメントアウト-->
        <!-- <li class="sub-menu" [style.display]="!menuDisplays['planGoods']['KYMW2000'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.planGoods && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2000"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW2000)"
            (click)="openDialogComponent(dialogComponents.KYMW2000)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">選定済商品数一覧</div>
          </a>
        </li> -->
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['publicationProduction'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.publicationProduction" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.publicationProduction = !parentMenusOpen.publicationProduction : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.publicationProduction = !parentMenusOpen.publicationProduction : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconPublicationProduction" ngbTooltip="誌面制作"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">誌面制作</div>
        <fa-icon [icon]="parentMenusOpen.publicationProduction ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="誌面制作"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.publicationProduction && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW1400'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1400" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW1400">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">コマ割</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2100'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/2100" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW2100">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">注文コード設定</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW4100'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW4100" (keydown.Space)="openDialogComponent(dialogComponents.KYMW4100)"
            (click)="openDialogComponent(dialogComponents.KYMW4100)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">統一企画点検リスト</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2600'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW2600" (keydown.Space)="openDialogComponent(dialogComponents.KYMW2600)"
            (click)="openDialogComponent(dialogComponents.KYMW2600)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">Ｗ掲載リスト出力</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2700'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/2700" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2700">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">基版コピー・フェーズ管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/2300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW2300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">印刷会社用データ出力</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW4400'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4400" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4400">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ページ・台割編集</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/2500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ページネーション設定</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['publicationProduction']['KYMW2200'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.publicationProduction && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW2200" (keydown.Space)="openDialogComponent(dialogComponents.KYMW2200)"
            (click)="openDialogComponent(dialogComponents.KYMW2200)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ＯＣＲデータメール送信</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['ecProduction'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.ecProduction" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.ecProduction = !parentMenusOpen.ecProduction : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.ecProduction = !parentMenusOpen.ecProduction : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconECProduction" ngbTooltip="EC制作"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">EC制作</div>
        <fa-icon [icon]="parentMenusOpen.ecProduction ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="EC制作"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.ecProduction && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW5300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/5300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW5300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ECカテゴリマスタ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW5400'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/5400" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW5400">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ECカテゴリ関連マスタ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW6800'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/6800" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6800">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ECカテゴリ変換マスタ一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW6500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/6500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ECタイムセールマスタ一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW5900'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW5900"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW5900)"
            (click)="openDialogComponent(dialogComponents.KYMW5900)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">EC企画商品一覧表</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW5500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/5500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW5500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">EC画像メンテ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW6000'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/6000" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6000">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">EC使用画像一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['ecProduction']['KYMW6100'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.ecProduction && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW6100"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW6100)"
            (click)="openDialogComponent(dialogComponents.KYMW6100)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">EC画像指示一覧表</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['imageManagement'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.imageManagement" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.imageManagement = !parentMenusOpen.imageManagement : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.imageManagement = !parentMenusOpen.imageManagement : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconImageManagement" ngbTooltip="画像管理"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">画像管理</div>
        <fa-icon [icon]="parentMenusOpen.imageManagement ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="画像管理"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.imageManagement && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['imageManagement']['KYMW1700'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1700" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.imageManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1700">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">画像作成管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['imageManagement']['KYMW0C00'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/0c00" routerLinkActive="active"
            [tabindex]="parentMenusOpen.imageManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW0C00" (keydown.Space)="routingTo($event)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">画像作成指示</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['imageManagement']['KYMW1704'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.imageManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW1704" (keydown.Space)="openDialogComponent(dialogComponents.KYMW1704)"
            (click)="openDialogComponent(dialogComponents.KYMW1704)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">画像個別登録</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['imageManagement']['KYMW1600'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1600" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.imageManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1600">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">画像確認</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['imageManagement']['KYMW1800'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.imageManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1800"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW1800)"
            (click)="openDialogComponent(dialogComponents.KYMW1800)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">画像チェックリスト出力</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['productPlanning'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.productPlanning" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.productPlanning = !parentMenusOpen.productPlanning : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.productPlanning = !parentMenusOpen.productPlanning : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconProductPlanning" ngbTooltip="運営商品企画"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">運営商品企画</div>
        <fa-icon [icon]="parentMenusOpen.productPlanning ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="運営商品企画"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.productPlanning && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['productPlanning']['KYMW7200'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7200" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.productPlanning && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7200">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">運営商品一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['productPlanning']['KYMW7300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.productPlanning && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">注文単位値引クーポン一覧</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['masterManagement'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.masterManagement" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.masterManagement = !parentMenusOpen.masterManagement : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.masterManagement = !parentMenusOpen.masterManagement : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconMasterManagement" ngbTooltip="マスタ管理"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">マスタ管理</div>
        <fa-icon [icon]="parentMenusOpen.masterManagement ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="マスタ管理"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.masterManagement && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW4800'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4800" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4800">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">クロス商品設定マスタ管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW7100'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/7100" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW7100">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">束ね企画回設定</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW4600'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/4600" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW4600">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">タグ管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW1500'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/1500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW1500">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">マーク・アイコンマスタ</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW0A00'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/0A00" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1"
            [class.disabled]="menuDisabled.KYMW0A00">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">組合員の声管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW2400'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/2400" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW2400">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ページパターン設定</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['masterManagement']['KYMW9200'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9200" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.masterManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9200">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">企画回管理</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['businessManagement'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.businessManagement" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.businessManagement = !parentMenusOpen.businessManagement : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.businessManagement = !parentMenusOpen.businessManagement : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconBusinessManagement" ngbTooltip="業務管理"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">業務管理</div>
        <fa-icon [icon]="parentMenusOpen.businessManagement ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="業務管理"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.businessManagement && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['businessManagement']['KYMW9400'] ? 'none' : ''">
          <a class="menu-item" href="javascript:void(0)" routerLinkActive="active"
            [tabindex]="parentMenusOpen.businessManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9400"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW9400)"
            (click)="openDialogComponent(dialogComponents.KYMW9400)">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">外部システム連携</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['businessManagement']['KYMW9300'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9300" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.businessManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9300">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">お知らせ編集</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['systemsManagement'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.systemsManagement" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.systemsManagement = !parentMenusOpen.systemsManagement : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.systemsManagement = !parentMenusOpen.systemsManagement : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconSystemsManagement" ngbTooltip="システム管理"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">システム管理</div>
        <fa-icon [icon]="parentMenusOpen.systemsManagement ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="システム管理"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.systemsManagement && menuOpen">
        <li class="sub-menu" [style.display]="!menuDisplays['systemsManagement']['KYMW9000'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9000" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9000">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ユーザ一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['systemsManagement']['KYMW9003'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9003" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9003">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">権限一覧</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['systemsManagement']['KYMW9006'] ? 'none' : ''">
          <a class="menu-item" routerLinkActive="active"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1"
            (keydown.Space)="openDialogComponent(dialogComponents.KYMW9006)"
            (click)="openDialogComponent(dialogComponents.KYMW9006)" [class.disabled]="menuDisabled.KYMW9006">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">パスワード変更</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['systemsManagement']['KYMW9009'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9009" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9009">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ユーザ階層管理</div>
          </a>
        </li>
        <li class="sub-menu" [style.display]="!menuDisplays['systemsManagement']['KYMW9100'] ? 'none' : ''">
          <a class="menu-item" routerLink="/kymw/9100" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1" [class.disabled]="menuDisabled.KYMW9100">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">ログ検索</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" (click)="eventDownloadHandler()" (keydown.Space)="eventDownloadHandler()"
            [tabindex]="parentMenusOpen.systemsManagement && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">マニュアルダウンロード</div>
          </a>
        </li>
      </ul>
    </li>

    <li class="root-menu" [style.display]="!parentMenuDisplays['develop'] ? 'none' : ''">
      <a class="menu-item parent-menu" [class.open]="parentMenusOpen.develop" [tabindex]="0"
        (keydown.Space)="menuOpen ? parentMenusOpen.develop = !parentMenusOpen.develop : menuOpen = true"
        (click)="menuOpen ? parentMenusOpen.develop = !parentMenusOpen.develop : menuOpen = true">
        <fa-icon class="menu-icon" [icon]="iconDevelop" ngbTooltip="開発"></fa-icon>
        <div class="menu-item-label" [class.menu-open]="parentMenusOpen" [class.menu-open]="menuOpen">開発</div>
        <fa-icon [icon]="parentMenusOpen.develop ? faCaretUp : faCaretDown" [class.menu-close]="!menuOpen"
          ngbTooltip="開発"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentMenusOpen.develop && menuOpen">
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/test" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">テスト</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7000" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集掲載商品選定（CX）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7001" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集掲載商品選定（バイヤー）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7006" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集商品選定依頼確認<br>（グループ長用）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7007" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">表紙・特集商品選定依頼確認<br>（担当バイヤー用）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7003" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特集商品提案状況確認<br>（取引先用）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7004" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">特集商品提案状況確認<br>（CXデザイン部用）</div>
          </a>
        </li>
        <li class="sub-menu">
          <a class="menu-item" routerLink="/kymw/7500" routerLinkActive="active" (keydown.Space)="routingTo($event)"
            [tabindex]="parentMenusOpen.develop && menuOpen ? 0 : -1">
            <div class="menu-item-label chotai9" [class.menu-open]="menuOpen">計画数確認</div>
          </a>
        </li>
      </ul>
    </li>
  </ul>

  <div class="menu-footer">
    <button class="toggle-button alt fa-icon-button" [tabindex]="0" type="button" (click)="menuOpen = !menuOpen"
      style="margin: 0 0 0 auto;">
      <fa-icon [icon]="menuOpen ? faArrowAltCircleLeft : faArrowAltCircleRight" size="2x"></fa-icon>
    </button>
  </div>
</div>